import { useContext, useMemo } from 'react';

import { ThemeContext } from '@authFlow/App/Contexts/ThemeContext';
import { storageManager } from '@authFlow/utils/SessionStorageManager';
import history from '@authFlow/App/history';

export const useLayoutFlags = (pathname: string) => {
  const { flowTheme } = useContext(ThemeContext);

  return useMemo(() => {
    const baseSignupFlowPages = [
      '/signup/',
      '/signup/confirm/',
      '/signup/subscription-consent/',
      '/signup/customize-flow/',
      '/signup/project-info/',
      '/signup/insights/',
      '/signup/get-free-trial/',
      '/signup/invite/',
      '/signup/info/',
      '/signup/marketing-source/',
    ];
    const entSolFlowPages = ['/signup/enterprise/', '/signup/enterprise-demo/'];
    const trialPageReg = new RegExp(/\/signup\/get-free-trial\/([\w-]+)/);
    const isBaseSignupFlow =
      baseSignupFlowPages.includes(pathname) || trialPageReg.test(pathname);
    const isEntSolSignupFlow = entSolFlowPages.includes(pathname);

    const isSemrushOnePlan =
      storageManager.get('userData')?.personalisedPlan === 'semrush-one';

    const isWowAISeoTheme = flowTheme === 'wow_ai_seo';

    const isWowAISeoFlow =
      (isWowAISeoTheme && isBaseSignupFlow) ||
      (isSemrushOnePlan && pathname.startsWith('/signup/get-free-trial/'));
    const showWowAISeoFlowFirstAnimation =
      isWowAISeoFlow &&
      pathname === '/signup/' &&
      !(
        history.location.state?.wowAISeoFirstScreenShown ||
        storageManager.get('wowAISeoFirstScreenShown')
      );

    const shouldShowAurora =
      (isWowAISeoTheme &&
        baseSignupFlowPages.includes(pathname) &&
        pathname !== '/signup/') ||
      (isSemrushOnePlan && pathname === '/signup/get-free-trial/') ||
      isEntSolSignupFlow;

    return {
      isBaseSignupFlow,
      isEntSolSignupFlow,
      isWowAISeoFlow,
      isWowAISeoTheme,
      shouldShowAurora,
      showWowAISeoFlowFirstAnimation,
    };
  }, [flowTheme, pathname]);
};
